.minimize-btn {
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 14px;
  display: flex;
}

.minimize-btn svg {
  stroke: var(--minimize-button-color, black);
}
